import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { hero } from "../mock";

const word = {
  hidden: { opacity: 0, y: 24 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: 0.1 + i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

const InlinePic = ({ src }) => (
  <span className="inline-block align-middle mx-2 rounded-2xl overflow-hidden h-[0.72em] w-[1.15em] translate-y-[-0.05em]">
    <img src={src} alt="" className="w-full h-full object-cover" />
  </span>
);

const Hero = () => {
  return (
    <section className="pt-32 md:pt-40 px-5">
      <div className="max-w-[1100px] mx-auto text-center">
        {/* Trusted */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex items-center justify-center gap-3 mb-8"
        >
          <div className="flex -space-x-3">
            {hero.founders.map((f, i) => (
              <img
                key={i}
                src={f}
                alt="founder"
                className="w-8 h-8 rounded-full border-2 border-[#ececec] object-cover"
              />
            ))}
          </div>
          <span className="text-[15px] text-[#141414]">{hero.trusted}</span>
        </motion.div>

        {/* Headline */}
        <h1 className="font-cal text-[#141414] leading-[1.02] text-[44px] sm:text-[64px] md:text-[86px]">
          <motion.span custom={0} variants={word} initial="hidden" animate="show" className="inline-block">
            Effortless
          </motion.span>{" "}
          <motion.span custom={1} variants={word} initial="hidden" animate="show" className="inline-block text-[#ff4d17]">
            Design
          </motion.span>
          <br />
          <motion.span custom={2} variants={word} initial="hidden" animate="show" className="inline-block">
            for
          </motion.span>
          <InlinePic src={hero.inlineImg1} />
          <motion.span custom={3} variants={word} initial="hidden" animate="show" className="inline-block">
            Design Startups
          </motion.span>
          <br />
          <motion.span custom={4} variants={word} initial="hidden" animate="show" className="inline-block">
            based in London,
          </motion.span>
          <InlinePic src={hero.inlineImg2} />
          <motion.span custom={5} variants={word} initial="hidden" animate="show" className="inline-block">
            UK
          </motion.span>
        </h1>

        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="max-w-[520px] mx-auto mt-8 text-[16px] md:text-[17px] text-[#5f5f5f] leading-relaxed"
        >
          {hero.subtitle}
        </motion.p>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          className="mt-8 flex justify-center"
        >
          <button
            onClick={() => document.querySelector("#pricing")?.scrollIntoView({ behavior: "smooth" })}
            className="group bg-[#1c1c1c] text-white text-[15px] pl-6 pr-2 py-2 rounded-full flex items-center gap-3 hover:bg-[#ff4d17] transition-colors"
          >
            {hero.cta.label}
            <span className="bg-white/15 group-hover:bg-white/25 rounded-full p-2 transition-colors">
              <ArrowRight size={16} />
            </span>
          </button>
        </motion.div>
      </div>

      {/* Banner */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-[1240px] mx-auto mt-16 rounded-t-[28px] overflow-hidden"
      >
        <img src={hero.banner} alt="showcase" className="w-full h-auto object-cover" />
      </motion.div>
    </section>
  );
};

export default Hero;
